import React, { useState, useEffect } from "react";
import PanOCR from "./PanOCR.js";
import AdharOCR from "./AdharOCR.js";
import AdharMask from "./AdharMask.js";
import Cheque from "./Cheque.js";
import BankStatement from "./BankStatement.js";
import DrivingLicense from "./DrivingLicense.js";
import Form16 from "./Form16.js";
import ItroService from "./ItroService.js";
// import Signature from "./Signature.js";
import NameMatch from "./NameMatch.js";
import VoterId from "./VoterId.js";
import DPStatement from "./DPStatement.js";
import Document from "./Document.js";
import Gst from "./Gst.js";
// import GstPan from "./GstPan";
// import VideoKyc from "./VideoKyc.js";
import SignMatch from "./SignMatch.js";
import AccountAgre from './AccountAgre.js'
import Passport from "./Passport.js";
import "./Bottabs.css";
import DownArrow from "../Components/images/downArrow.png";
import AinxtTech_logo from "../Components/images/AinxtTech_logo.png";
import FaceMatch from "./FaceMatch.js";
import { useNavigate } from "react-router-dom";
import Read from "./Read.js";
import RcBook from "./RcBook.js";
import Esign from "./Esign.js";
import Login from "./Login.jsx";
import Otp from "./Otp.js";
import PennyDrop from "./PennyDrop.js";
import PanSeeding from "./PanSeeding.js";
import SignCrop from "./SignCrop.js";
import Binary from "./Binary.js";
import EsignCord from "./EsignCord.jsx";
import EsignPdf from "./EsignPdf.js";
import DocClassifier from "./DocClassifier.js";
import PrefillApi from "./PrefillApi.js";
import PreFillequifax from './PreFillequifax.js';
import SignSdk from "./SignSdk.js";
import AadharMaskNew from "./AadharMaskNew.js";
import DocGenAi from "./DocGenAi.js";
import BankAnlyze from "./BankAnalyze.js";
import CDSLData from "./CDSLData.js";
import InvoiceData from "./InvoiceData.js";
import Rpd from "./Rpd.js";
import NDSLDemo from './NSDLDeMO.js';
import NudityCheck from "./NudityCheck.js";
import BankAddition from "./BankAddition.js";
import PIData from "./PIData.js";
import SignSdkCheck from './signCheck.js'
import LivelinessTest from "./FaceCheckTest.js";
import SignSdkTest from './signatureTest.js'
import NomineeOptOut from "./NomineeOptOut.jsx";
import { AnyDocumentOCR } from "./AnyDocumentOCR.jsx";
import { MobilePiData } from "./MobilePiData.js";
import OvdSDK from "./ovd.js";
import VipvCheck from "./VipvCheck.jsx";
import NSDLPanVerification from "./NSDLPanVerification.js";
import MobilePrefill from "./MobilePrefill.js";
import PrefillApiZdvisor from "./PrefillApiZdvisor.js";
// import Gst from "./Gst"

// ---------------------------------------------------------------------------
// Menu configuration (data driven, so the sidebar / top nav / content are
// all generated from one place instead of being repeated by hand).
// `key`    -> component shown in the content area (see COMPONENTS below)
// `action` -> opens an external page / runs a function (see `actions` below)
// ---------------------------------------------------------------------------
const ZDVISOR_SIDEBAR = [
  { key: "NSDLPanVerification", label: "NSDL Pan Verification" },
  { key: "PrefillApiZdvisor", label: "PrefillApi(PAN)" },
  { key: "MobilePrefill", label: "Profile Fetch (Mobile)" },
];
const ZDVISOR_NAV = ZDVISOR_SIDEBAR;

const RESTRICTED_SIDEBAR = [
  { key: "LivelinessSdkCheck", label: "Liveliness Check" },
];
const RESTRICTED_NAV = [
  { key: "NameMatch", label: "Name Match" },
  { key: "FaceMatch", label: "Face Match" },
  { key: "SignSdkCheck", label: "Sign Check" },
  { key: "LivelinessSdkCheck", label: "Liveliness Check" },
];

const DEFAULT_SIDEBAR = [
  { key: "PanOCR", label: "PAN OCR" },
  { key: "AdharOCR", label: "Aadhaar OCR" },
  { key: "AdharMask", label: "Aadhaar Masking" },
  { key: "ChequeOCR", label: "Cheque OCR" },
  { key: "BankStatement", label: "Bank Statement OCR" },
  { key: "DrivingLicense", label: "Driving License OCR" },
  { key: "Form16", label: "Form16 OCR" },
  { key: "ItroService", label: "Income Tax Return OCR" },
  { key: "VoterID", label: "Voter ID OCR" },
  { key: "DPStatement", label: "DP Statement OCR" },
  { key: "Passport", label: "Passport OCR" },
  { key: "Document", label: "Document Recognition Check" },
  { key: "DocClassifier", label: "Document Classifier" },
  { key: "Read", label: "Document Quality Check" },
  { key: "Gst", label: "GST Check" },
  { key: "RcBook", label: "RC Book Check" },
  { key: "AadharMaskNew", label: "AadharMask New" },
  { key: "DocGenAi", label: "Financial Proof" },
  { key: "PIData", label: "PI DATA" },
  { key: "BankAddition", label: "Bank Addition" },
  { key: "BankAnlyze", label: "Bank Anlyze" },
];
const DEFAULT_NAV = [
  { key: "NameMatch", label: "Name Match" },
  { key: "PrefillApi", label: "PrefillApi(PAN)" },
  // { key: "Binary", label: "Sign Crop" },
  // { key: "PreFillequifax", label: "PrefillApi(Name)" },
  { key: "CDSLData", label: "AOF KYC Demo" },
  { key: "NSDLDemo", label: "KYC AUDIT Demo" },
  // { key: "NudityCheck", label: "Nudity Check" },
  // { key: "InvoiceData", label: "Invoice" },
  { key: "AccountAgre", label: "Account Aggregator" },
  { key: "Rpd", label: "Rpd & PL" },
  { key: "FaceMatch", label: "Face Match" },
  // { key: "EsignCord", label: "Esign Co-ordinates" },
  // { key: "Esign", label: "Esign" },
  // { key: "EsignPdf", label: "EsignPdf" },
  // { key: "Otp", label: "OTP Gateaway" },
  { key: "PanSeeding", label: "PAN Verification" },
  { key: "PennyDrop", label: "Penny Drop/Less" },
  // { key: "SignCrop", label: "Binary & Background Crop" },
  { key: "SignMatch", label: "SignMatch" },
  { action: "EkycJourney", label: "EkycJourney" },
  { action: "EkycAdmin", label: "EkycAdmin" },
  { action: "FaceLiveliness", label: "AINXT Face Liveliness" },
  { action: "AinxtVideoOtp", label: "AINXT Video OTP" },
  { action: "DigiLocker", label: "Digi Locker" },
  { key: "SignSdkCheck", label: "Sign Check" },
  { key: "LivelinessSdkCheck", label: "Liveliness Check" },
  { key: "NomineeOptOut", label: "Nominee-Opt-Out" },
  { key: "AnyDocumentOCR", label: "Any Document OCR" },
  { key: "MobilePiData", label: "Mobile PI data" },
  { key: "OvdSDK", label: "OVD" },
  { key: "VipvCheck", label: "VIPV Check" },
];

// key -> component rendered in the content area
const COMPONENTS = {
  NSDLPanVerification,
  PrefillApiZdvisor,
  MobilePrefill,
  PanOCR,
  AdharOCR,
  AdharMask,
  ChequeOCR: Cheque,
  BankStatement,
  DrivingLicense,
  Form16,
  ItroService,
  VoterID: VoterId,
  DPStatement,
  Passport,
  // Signature,
  NameMatch,
  PrefillApi,
  PreFillequifax,
  FaceMatch,
  // VideoOtp,   // opened through the AINXT Video OTP action instead
  // DigiLocker, // opened through the Digi Locker action instead
  Document,
  PIData,
  DocClassifier,
  Read,
  BankAddition,
  Gst,
  // GstPan,
  // VideoKyc,
  EsignCord,
  Esign,
  EsignPdf,
  PennyDrop,
  RcBook,
  Otp,
  PanSeeding,
  SignCrop,
  Binary,
  SignMatch,
  SignSdk,
  SignSdkCheck,
  LivelinessSdkCheck: LivelinessTest,
  AadharMaskNew,
  DocGenAi,
  BankAnlyze,
  CDSLData,
  InvoiceData,
  NudityCheck,
  AccountAgre,
  Rpd,
  NSDLDemo: NDSLDemo,
  SignSdkTest,
  NomineeOptOut,
  AnyDocumentOCR,
  MobilePiData,
  OvdSDK,
  VipvCheck,
};

// at this width and below the sidebar is a closed overlay (see Bottabs.css)
const MOBILE_BREAKPOINT = 992;

export default function BotTabs() {
  // const styleObj = {
  //   fontSize: 70,
  //   color: "#FF0000",
  //   textAlign: "center",
  //   paddingTop: "100px",
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  //   height: "100vh",
  // };

  const [show, setShow] = useState("");
  const Navigate = useNavigate();

  const [cardData, setCardData] = useState({
    name: "",
    pan_no: "",
    father_name: "",
    date_of_birth: "",
  });
  const [localData, setLocalData] = useState({});
  const [restricted, setRestricted] = useState(false);
  const [isZdvisor, setIsZdvisor] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(
    () => window.innerWidth > MOBILE_BREAKPOINT
  );
  var Active = sessionStorage.getItem("Loggedin");

  useEffect(() => {
    let data = JSON.parse(sessionStorage.getItem("Loggedin"));
    // console.log('data', data);
    if (!data) return; // not logged in, the Login page is rendered instead
    setRestricted(data.Username === "arpit.kumar@univest.in");
    setIsZdvisor(data.Username === "shailendra.awasthi@zdvisor.com");
    setLocalData(data);
  }, []);

  // close the sidebar when the window shrinks to a small screen
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth <= MOBILE_BREAKPOINT) setSidebarOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // function menuClick() {
  //   var element = document.getElementById("leftMenu");
  //   element.classList.toggle("show");
  // }
  const toggleSidebar = () => setSidebarOpen((open) => !open);


  const VideoOtp = () => {
    // 👇️ redirect to external URL

    window.open(
      "https://main.dr63ajlfsncfr.amplifyapp.com/?s=ainxt&k=79993401FEAD58EE8B4965C62CCE60E4&ip=100&request_id=1312321",
      "_blank",
      "noopener,noreferrer"
    );

    return null;
  };

  const EkycJourney = () => {
    // 👇️ redirect to external URL

    window.open(
      "https://test.d2q9oqc2xjzy3b.amplifyapp.com/",
      "_blank",
      "noopener,noreferrer"
    );

    return null;
  };

  const EkycAdmin = () => {
    // 👇️ redirect to external URL

    window.open(
      // "https://uat.d25qk1ozjvhbw3.amplifyapp.com/login/TEST2",
      "https://demo.getseto.com/mobile",
      "_blank",
      "noopener,noreferrer"
    );
    return null;
  };

  const AinxtVideoOtp = () => {
    // 👇️ redirect to external URL

    window.open(
      "https://main.d2joyqdqjim40.amplifyapp.com/?s=ainxt&k=79993401FEAD58EE8B4965C62CCE60E4&ip=100&request_id=1312321",
      "_blank",
      "noopener,noreferrer"
    );

    return null;
  };

  const DigiLocker = () => {
    // console.log("okkkkkkkkkkkkkkkkk", )

    var myHeaders = new Headers();
    myHeaders.append("x-api-key", "CAz0T7jv0g570ywQ38RE42G6XhbmLHOs2iOsUA9p");
    myHeaders.append("key", "79993401FEAD58EE8B4965C62CCE60E4");
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      request_id: "1212121",
      // "ts": "2022110600",
      ts: GetTs(new Date()),
      redirect_url: "https://main.d3czbq2aohenwt.amplifyapp.com/DigilockerRe",
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://83r15wflik.execute-api.ap-south-1.amazonaws.com/v3/digilocker/link",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        window.open(`${result.result.link}`, "_blank", "noopener");
        // console.log(result.result.link)
        // console.log(result.resultId, "frfr")
        // console.log(result)
      })
      .catch((error) => ("error", error));

    function GetTs(Date) {
      let d = Date.toLocaleString("en-GB", {
        timeZone: "Asia/Kolkata",
      });
      let parts = d.split(",")[0].split("/");
      let partsNext = d.split(",")[1].split(":");
      return (
        parts[2] +
        twoDigits(parts[1]) +
        twoDigits(parts[0]) +
        twoDigits(partsNext[0]) +
        twoDigits(partsNext[1]) +
        twoDigits(partsNext[2])
      );
    }
    function twoDigits(d) {
      d = parseInt(d);
      if (0 <= d && d < 10) return "0" + d.toString();
      if (-10 < d && d < 0) return "-0" + (-1 * d).toString();
      return d.toString();
    }
    // return ;
  };

  // const redirectface = () => {
  //   let RefId = Math.floor(Math.random() * 1000);
  //   console.log(RefId);

  //   fetch(
  //     `https://nyrdggq2bg.execute-api.ap-south-1.amazonaws.com/default/get_caps_liveliness_token?RefId=${RefId}&Redirect_url=${"http://localhost:4200/selfie"}`,
  //     {
  //       method: "POST",

  //       headers: {
  //         "x-api-key": "z1Oo4yV1r3859sghyNGez9RcrfEB6GqCKPuiwlT7",
  //         key: "VHLCAONDFH8I5IOUJDXON4AQLVGZ7BTZ",
  //       },
  //     }
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       // setRes(result.Token);
  //       console.log(result.Token);
  //       // window.location.href = `https://uat.d1eoc9d18k80hw.amplifyapp.com/selfie?t=${result.Token}`;
  //       window.open(
  //         `https://main.d2ed1hvzd5y30f.amplifyapp.com/#/selfie?t=${result.Token}`
  //       );
  //     })
  //     .catch((error) => console.log("error", error));
  // };

  const redirectNewFace = () => {
    if (sessionStorage.getItem("username") === "aisha@finnup.in") {
      return;
    }
    let RefId = Math.floor(Math.random() * 1000);
    console.log(RefId);

    fetch(
      `https://utexse375h.execute-api.ap-south-1.amazonaws.com/default/get_ainxt_liveliness_token?RefId=${RefId}&Redirect_url=${"https://www.google.com/"}`,
      {
        method: "POST",

        headers: {
          "x-api-key": "LaZtThwV4R3jxJuXSY2eb2tboVU9BCNT5ZOvzewe",
          key: "A1B30AA035D76A08465399672DF5AC44",
        },
      }
    )
      .then((response) => response.json())
      .then((result) => {
        // setRes(result.Token);
        console.log(result.Token);
        // window.location.href = `https://uat.d1eoc9d18k80hw.amplifyapp.com/selfie?t=${result.Token}`;
        window.open(
          `https://livelinessuat.ainxtapi.com/#/selfie?t=${result.Token}`
        );

        console.log(result);
      })
      .catch((error) => console.log("error", error));
  };

  const Logout = () => {
    sessionStorage.clear("loggedin");
    Navigate("/");
  };

  const actions = {
    EkycJourney,
    EkycAdmin,
    AinxtVideoOtp,
    DigiLocker,
    FaceLiveliness: redirectNewFace,
  };

  // pick the menus for the logged in user
  const sidebarItems = isZdvisor
    ? ZDVISOR_SIDEBAR
    : restricted
    ? RESTRICTED_SIDEBAR
    : DEFAULT_SIDEBAR;
  const navItems = isZdvisor
    ? ZDVISOR_NAV
    : restricted
    ? RESTRICTED_NAV
    : DEFAULT_NAV;

  const handleItemClick = (item) => {
    if (item.action) {
      actions[item.action]();
    } else {
      setShow(item.key);
    }
  };

  const handleSidebarClick = (item) => {
    handleItemClick(item);
    // on phones the sidebar is an overlay, so close it after choosing
    if (window.innerWidth <= MOBILE_BREAKPOINT) setSidebarOpen(false);
  };

  const ActiveComponent = COMPONENTS[show];
  const currentLabel = [...sidebarItems, ...navItems].find(
    (item) => item.key && item.key === show
  )?.label;

  const renderItems = (items, onClick) =>
    items.map((item) => (
      <li
        key={item.key || item.action}
        className={item.key && item.key === show ? "active" : ""}
        onClick={() => onClick(item)}
      >
        {item.label}
      </li>
    ));

  return (
    <>
      {Active ? (
        <div className="wrap">
          {sidebarOpen && (
            <div
              className="sidebarBackdrop"
              onClick={() => setSidebarOpen(false)}
            ></div>
          )}

          <div
            className={`leftPanel${sidebarOpen ? "" : " closed"}`}
            id="leftMenu"
          >
            <div className="headingMenu">
              <div>
                OCR{" "}
                <span className="smallTextMenu">
                  OCR Services &nbsp;
                  <img alt="DownArrow" src={DownArrow} />
                </span>
              </div>
              {/* <button
                type="button"
                className="closeSidebar"
                aria-label="Close sidebar"
                title="Close sidebar"
                onClick={() => setSidebarOpen(false)}
              >
                &times;
              </button> */}
            </div>

            <ul className="leftMenu">
              {renderItems(sidebarItems, handleSidebarClick)}
            </ul>
          </div>

          <div className={`rightPanel${sidebarOpen ? "" : " expanded"}`}>
            <section id="header">
              <div className="topBar">
                <div className="topBarLeft">
                  <button
                    type="button"
                    className="menu_icon"
                    aria-label="Toggle sidebar"
                    title="Toggle sidebar"
                    onClick={toggleSidebar}
                  >
                    <span></span>
                    <span></span>
                    <span></span>
                  </button>
                  <img
                    alt="AinxtTech_Logo"
                    src={AinxtTech_logo}
                    width="100"
                    height="auto"
                  />
                </div>

                <div className="topBarRight">
                  <button className="btn btn-primary" onClick={Logout}>
                    Logout
                  </button>
                </div>
              </div>
            </section>

            <section id="main">
              <div className="nav">
                <ul className="navBar">
                  {renderItems(navItems, handleItemClick)}
                </ul>
              </div>

              <div className="mainDiv">
                <div className="row">
                  <div className="col-12 breadcrumbs">
                    {/* <a href="">Home</a> / <a href="">Dashboard</a> */}
                    <span>Home</span> / <span>Dashboard</span>
                    {currentLabel && (
                      <>
                        {" "}
                        / <span className="current">{currentLabel}</span>
                      </>
                    )}
                  </div>
                  {ActiveComponent ? (
                    <div>
                      <ActiveComponent />
                    </div>
                  ) : (
                    <div className="welcomeCard">
                      <h3>
                        Welcome{localData.Username ? `, ${localData.Username}` : ""}
                      </h3>
                      <p>
                        Pick a service from the sidebar or the top menu to get
                        started.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </div>
        </div>
      ) : (
        <h1>
          {" "}
          <Login />
        </h1>
      )}
    </>
  );
}
